/** @format */

import { Alert, Backdrop, Box, CircularProgress } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useStoreActions, useStoreState } from "easy-peasy";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import BasicTabs from "./CustomTabPanel";
import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import { useHistory } from "react-router-dom";
export default function EventManager() {
    const isMobile = useMediaQuery("(max-width:768px)");
    const queryClient = new QueryClient();
    const [loading, setLoading] = useState(true);
    const [eventsData, setEventsData] = useState(null);
    const noData = typeof eventsData === "undefined" || eventsData === null || eventsData?.id == 0;
    const [currentPageData, setCurrentPageData] = useState(
        {
            "filter": "",
            "skip": 0,
            "take": 5,
            "filterBy": "",
            "sortParams": "",
            "EventStatus": "all",
        }
    );
    const timeout = () => {
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    }

    useEffect(() => {
        try {
            fetch(`/api/Event/GetAllEventsSorted`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(currentPageData)
            })
                .then((response) => response.json())
                .then((data) => {
                    setEventsData(data);
                    timeout();
                })
                .catch((error) => {
                    console.log("Error fetching data: ", error);
                    timeout();
                });
        } catch (ex) {
            timeout();
        }
    }, []);

    

    useEffect(() => {
        try {
            let currentDateTime = new Date().toLocaleString();
            fetch(`/api/Auth/FetchJwtToken?userName=xxx&startDateTime=${currentDateTime}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(currentPageData)
            })
                .then((response) => response.json())
                .then((data) => {
                    localStorage.setItem('JWTToken', data.token);
                    localStorage.setItem('lastActiveTime', currentDateTime);
                })
                .catch((error) => {
                    console.log("Error fetching data: ", error);

                });
        } catch (ex) {
            console.log("Error fetching data: ", ex?.message);
        }
        timeout();
    }, []);

    const [eventSearchBy, setEventSearchBy] = useState(localStorage.getItem('EventSearchBy'));

    useEffect(() => {
        if (eventSearchBy === undefined || eventSearchBy === null) {
            setEventSearchBy("pilotIdOrPhone");
            localStorage.setItem('EventSearchBy', "pilotIdOrPhone");
        }
    }, []);

    const handleEventSearchBy = (value) => {
        setEventSearchBy(value);
        localStorage.setItem('EventSearchBy', value);
    }

    return (
        <>
            <Helmet>
                <title> Event Search | Check In App </title>
            </Helmet>

            <Box
                sx={{
                    width: isMobile ? "100%" : "95%",
                    height: "100vh", // Set the height to the window height
                }}
            >
                {noData ? (
                    <>
                        <Alert severity="info" sx={{ fontSize: "15px", marginTop: "8px" }}>
                            No record was found.
                        </Alert>
                    </>
                ) : (
                    <>

                        <QueryClientProvider client={queryClient}>
                            <div className="bg-white rounded-lg p-8 space-y-4 flex flex-col shadow-2xl">
                                <div className="text-center p-4 space-y-6 ">
                                    <h2 className="text-xl text-[#8a2432] font-bold">Below you can manage your check-in events. Please choose an action.</h2>
                                    <div class="grid grid-cols-3 items-right py-0">
                                        <div></div>
                                        <div class="flex justify-start items-right space-x-3">
                                            <FormControl component="fieldset">
                                                <div>
                                                    <RadioGroup
                                                        row
                                                        name="filter"
                                                        defaultValue={eventSearchBy}
                                                        onChange={(event) => handleEventSearchBy(event.target.value)}
                                                    >
                                                        <FormControlLabel control={<label />} label="Search By:" />
                                                        <FormControlLabel value="pilotIdOrPhone" control={<Radio />} label=" Pilot ID or Phone" />
                                                        <FormControlLabel value="all" control={<Radio />} label="All" />
                                                    </RadioGroup>
                                                </div>
                                            </FormControl>
                                        </div>
                                    </div>
                                    <Box
                                        sx={{
                                            border: "1px solid gray",
                                            borderRadius: "16px",
                                            padding: "12px",
                                        }}
                                    >
                                        <BasicTabs {...eventsData} />
                                    </Box>
                                </div>
                            </div>
                        </QueryClientProvider>
                    </>
                )}
                <Backdrop
                    sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={loading}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
            </Box>
        </>
    );
}
